import React from "react";
import "./Testimonial.css";

import userImage1 from "../../assets/1.jpeg";
import userImage2 from "../../assets/1.jpeg";
import userImage3 from "../../assets/1.jpeg";
import userImage4 from "../../assets/1.jpeg";
import userImage5 from "../../assets/1.jpeg";

function Testimonials() {
  const testimonials = [
    {
      text: "I made ₦750,000 in my first week just answering scheduled calls. It feels like I finally got paid for my time.",
      name: "Adaeze Nwosu",
      role: "Relationship Manager",
      city: "Lagos",
      earning: "₦750,000 / week",
      image: userImage1,
    },
    {
      text: "No more 'missed' calls or excuses. My clients calls to book, they pay, and I show up ready. OKIRI turned my daily hustle into a structured business.",
      name: "Tobi Adebayo",
      role: "Fitness Instructor",
      city: "Abuja",
      earning: "₦420,000 / week",
      image: userImage2,
    },
    {
      text: "As a content creator, people always want “quick advice calls”. Now it’s clean: rate, timer, and paid minutes. No drama.",
      name: "Kemi Ojo",
      role: "Content Creator",
      city: "Ibadan",
      earning: "₦310,000 / week",
      image: userImage3,
    },
    {
      text: "I used to waste a lot of time on long ‘free’ calls. With OKIRI, I control my time and my audience respects it.",
      name: "Chinedu Eze",
      role: "Business personnel",
      city: "Enugu",
      earning: "₦520,000 / week",
      image: userImage4,
    },
    {
      text: "I charge per minute and it’s straightforward. My followers feel closer, and I’m earning without being overwhelmed.",
      name: "Ifeoma Okafor",
      role: "Creator & Life coach",
      city: "Port Harcourt",
      earning: "₦280,000 / week",
      image: userImage5,
    },
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials__container">
        <div className="testimonials__header">
          <h2>
            Testimonies from people using{" "}
            <span className="highlight">OKIRI</span>
          </h2>
          <p>
            No long stories — just results from people earning with paid calls.
          </p>
        </div>

        <div className="testimonials__grid">
          {testimonials.map((t, index) => (
            <article className="testimonialCard" key={index}>
              <div className="testimonialCard__top">
                <div className="testimonialCard__pills">
                  <span className="pill pill--earn">{t.earning}</span>
                  <span className="pill pill--loc">{t.city}</span>
                </div>

                <span className="testimonialCard__quote" aria-hidden="true">
                  “
                </span>
              </div>

              <p className="testimonialCard__text">{t.text}</p>

              <div className="testimonialCard__footer">
                {/* <img
                  src={t.image}
                  alt={`${t.name} avatar`}
                  className="testimonialCard__avatar"
                  loading="lazy"
                  draggable="false"
                /> */}

                <div className="testimonialCard__meta">
                  <p className="testimonialCard__name">{t.name}</p>
                  <p className="testimonialCard__role">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
